import { isNilOrEmpty } from 'helpers';

export interface IGeocodeInfo { latitude?: any; longitude?: any; geocodeBad?: boolean }
export function addressHasGoodGeocode(address: IGeocodeInfo) {
  const geocodeOkay = !isNilOrEmpty(address)
        && address.geocodeBad !== true
        && !isNilOrEmpty(address.latitude)
        && !isNilOrEmpty(address.longitude);
  return geocodeOkay;
}
